import React from "react";
import PoweredByShosay from "./PoweredByShosay";
import WallHero, { heroFields } from "./WallHero";

// Shared page furniture for every Wall of Love theme: the full-height tinted
// canvas, the name/intro header, the loading and empty states, and the
// Powered by pill.
//
// Walls are a page takeover, so the chrome is the same everywhere and only
// the body between the header and the footer changes per theme. Themes that
// need to own the whole viewport (Video Reels, for one) pass bare so they can
// paint edge to edge.
const WallChrome = ({
  wall,
  loaded,
  count,
  children,
  bare = false,
  maxWidth = "max-w-7xl",
}) => {
  const bg = wall.bg_color || "#fafaf7";
  const accent = wall.primary_color || "#3E8DFF";
  const { enabled: heroOn, any: hasHero } = heroFields(wall);

  if (bare) {
    return (
      <div className="min-h-screen w-full" style={{ backgroundColor: bg }}>
        {children}
        <PoweredByShosay />
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full" style={{ backgroundColor: bg }}>
      {/* No hero means no heading furniture at all, wall name included. The
          page opens straight onto the proofs. */}
      {heroOn && (
        <header className={`px-6 sm:px-10 pt-12 sm:pt-20 ${hasHero ? "pb-12 sm:pb-16 text-center" : "pb-10"} ${maxWidth} mx-auto`}>
          <div className="text-xs font-bold uppercase tracking-[0.3em]" style={{ color: accent }}>
            {wall.name}
          </div>

          <WallHero wall={wall} accent={accent} />
        </header>
      )}

      {!loaded && (
        <div className="text-center text-slate-400 py-12">Loading testimonials…</div>
      )}

      {loaded && count === 0 && (
        <div className="text-center text-slate-500 py-12">No approved testimonials yet.</div>
      )}

      <main className={`px-6 sm:px-10 pb-20 ${heroOn ? "" : "pt-12 sm:pt-16"} ${maxWidth} mx-auto`}>
        {children}
      </main>

      <PoweredByShosay />
    </div>
  );
};

export default WallChrome;
